export const accommodations = [
  {
    id: 1,
    name: "텐진 감성 한옥 스튜디오",
    area: "텐진",
    tag: "감성 인테리어",
    hashtags: ["#텐진쇼핑구역", "#커플추천", "#가성비"],
    rating: 4.98,
    reviewCount: 142,
    price: "₩95,000",
    maxGuests: 2,
    beds: 1,
    features: ["텐진역 도보 3분", "한국어 소통 100%", "넷플릭스 제공"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://public.readdy.ai/ai/img_res/ffec639f6fb456cef9dffc838bcf981a.jpg",
    hostName: "박민지 호스트",
    needsRealPhoto: true,
    description: "텐진 한복판에 자리한 감성 가득한 스튜디오입니다. 한국 호스트 박민지 씨가 직접 큐레이션한 인테리어로 마치 서울의 핫한 에어비앤비에 온 듯한 기분을 느낄 수 있어요. 텐진역 3번 출구에서 도보 3분 거리라 이동이 매우 편리합니다.\n\n숙소 내부는 내추럴 우드 톤과 화이트 벽면의 조화가 아름답고, 넷플릭스가 연결된 55인치 TV와 드립 커피 세트가 기본 제공돼요. 체크인은 비대면으로 진행되지만, 카카오톡으로 항상 연락 가능하니 불편함 없이 체류하실 수 있습니다.\n\n근처 도보 5분 이내에 이온몰 텐진, 파르코 백화점, 미츠코시 등 쇼핑 명소가 즐비해 쇼핑을 좋아하시는 분들께 특히 인기 있는 숙소예요. 맛집 추천은 호스트에게 카카오톡으로 문의하시면 즉각 응답해드립니다.",
    locationDesc: "텐진역 3번 출구 도보 3분 / 미츠코시 백화점 도보 5분 / 나카스 도보 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=minimalist%20Japanese%20studio%20bedroom%20white%20walls%20natural%20wood%20floor%20plants%20morning%20light%20cozy%20warm&width=800&height=550&seq=101&orientation=landscape",
      "https://readdy.ai/api/search-image?query=modern%20compact%20Japanese%20kitchen%20white%20cabinet%20clean%20countertop%20coffee%20maker%20small%20apartment&width=800&height=550&seq=102&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Japanese%20apartment%20bathroom%20clean%20white%20tiles%20modern%20shower%20minimalist%20design&width=800&height=550&seq=103&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Tenjin%20street%20shopping%20area%20daytime%20pedestrian%20street%20view&width=800&height=550&seq=104&orientation=landscape",
    ],
  },
  {
    id: 2,
    name: "하카타 럭셔리 패밀리 아파트",
    area: "하카타",
    tag: "가족 여행 추천",
    hashtags: ["#하카타역근처", "#가족여행적합", "#넓은공간"],
    rating: 4.96,
    reviewCount: 89,
    price: "₩210,000",
    maxGuests: 6,
    beds: 3,
    features: ["하카타역 도보 5분", "6인 가족 가능", "세탁기 완비"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=spacious%20modern%20Japanese%20apartment%20living%20room%20with%20comfortable%20sofas%20natural%20light%20large%20windows%20city%20view%20Fukuoka&width=600&height=400&seq=2&orientation=landscape",
    hostName: "김서연 호스트",
    needsRealPhoto: true,
    description: "하카타역에서 걸어서 5분, 최대 6명이 함께 지낼 수 있는 넓은 패밀리 아파트입니다. 호스트 김서연 씨는 후쿠오카에서 10년 넘게 생활한 한국인으로, 아이 동반 가족 여행의 불편함을 누구보다 잘 알기에 필요한 것들을 모두 세심하게 준비해두셨어요.\n\n세탁기·건조기, 식기세척기, 어린이용 식기, 유아 포함 각종 안전 용품이 완비되어 있습니다. 방 3개에 화장실 2개라 가족이 편안하게 지내실 수 있으며, 넓은 거실에서 함께 식사하기에도 좋습니다.\n\n근처 캐널시티 하카타, 하카타 리버레인 쇼핑몰, 다자이후 온천 당일치기 이동도 편리해요. 아이들과 함께 라멘 스타디움 방문도 강력 추천드립니다. 긴급 상황 발생 시 한국어로 즉시 대응 가능합니다.",
    locationDesc: "하카타역 서쪽 출구 도보 5분 / 캐널시티 하카타 도보 10분 / 나카스 도보 15분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=spacious%20Japanese%20family%20apartment%20living%20room%20dining%20area%20comfortable%20large%20sofa%20natural%20light%20bright%20windows&width=800&height=550&seq=201&orientation=landscape",
      "https://readdy.ai/api/search-image?query=modern%20Japanese%20apartment%20bedroom%20with%20twin%20beds%20children%20room%20bright%20clean&width=800&height=550&seq=202&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Japanese%20apartment%20fully%20equipped%20kitchen%20family%20size%20refrigerator%20dishwasher%20modern%20appliances&width=800&height=550&seq=203&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Hakata%20station%20Fukuoka%20busy%20modern%20train%20station%20exterior%20daytime&width=800&height=550&seq=204&orientation=landscape",
    ],
  },
  {
    id: 3,
    name: "나카스 리버뷰 로맨틱 룸",
    area: "나카스",
    tag: "커플 추천",
    hashtags: ["#나카스", "#커플추천", "#야경뷰"],
    rating: 4.99,
    reviewCount: 201,
    price: "₩130,000",
    maxGuests: 2,
    beds: 1,
    features: ["나카강 뷰", "야경 최고", "카카오톡 24시간 상담"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=romantic%20Japanese%20apartment%20room%20with%20beautiful%20river%20night%20view%20from%20window%20cozy%20bed%20warm%20amber%20lighting%20minimal%20decor&width=600&height=400&seq=3&orientation=landscape",
    hostName: "이준호 호스트",
    needsRealPhoto: true,
    description: "후쿠오카 최고의 야경으로 손꼽히는 나카강 뷰를 창문 너머로 즐길 수 있는 로맨틱 룸입니다. 에어비앤비 후쿠오카 지역 커플 숙소 1위를 유지 중인 곳으로, 수많은 한국인 커플들이 특별한 추억을 만든 곳이에요.\n\n창문 너머로 나카강의 반짝이는 야경이 펼쳐지고, 아름다운 조명 아래 2인용 테이블에서 와인 한 잔을 즐길 수 있도록 세팅되어 있습니다. 환영 꽃다발과 스파클링 와인은 기본 제공이에요.\n\n나카스 야타이(포장마차 거리)가 도보 3분 거리라 저녁 식사는 정말 특별하게 즐기실 수 있어요. 이준호 호스트는 나카스 맛집 예약 대행 서비스도 제공하니 꼭 활용해 보세요. 카카오톡으로 24시간 연락 가능합니다.",
    locationDesc: "나카스역 도보 3분 / 나카스 야타이(포장마차) 도보 3분 / 텐진 도보 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=romantic%20couple%20Japanese%20apartment%20night%20view%20river%20lights%20reflection%20from%20large%20window%20dark%20cozy%20atmosphere%20candles&width=800&height=550&seq=301&orientation=landscape",
      "https://readdy.ai/api/search-image?query=elegant%20Japanese%20bedroom%20dark%20tones%20romantic%20mood%20lighting%20luxury%20bedding%20premium%20hotel%20quality&width=800&height=550&seq=302&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Nakasu%20river%20Fukuoka%20night%20view%20glowing%20neon%20food%20stalls%20reflections%20on%20water&width=800&height=550&seq=303&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Nakasu%20yatai%20outdoor%20food%20stalls%20at%20night%20lantern%20lights%20crowd%20local%20atmosphere&width=800&height=550&seq=304&orientation=landscape",
    ],
  },
  {
    id: 4,
    name: "오호리 공원 뷰 모던 하우스",
    area: "오호리",
    tag: "자연 뷰",
    hashtags: ["#오호리공원", "#조용한동네", "#비대면체크인"],
    rating: 4.95,
    reviewCount: 67,
    price: "₩155,000",
    maxGuests: 4,
    beds: 2,
    features: ["오호리 공원 뷰", "조용한 주거지역", "비대면 체크인"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=modern%20Japanese%20house%20interior%20bright%20living%20space%20with%20park%20view%20through%20large%20windows%20minimalist%20Scandinavian%20style%20furniture%20clean%20white%20walls&width=600&height=400&seq=4&orientation=landscape",
    hostName: "최지은 호스트",
    needsRealPhoto: true,
    description: "오호리 공원을 내려다보는 통창이 자랑인 모던 하우스입니다. 도심의 번잡함을 벗어나 고요한 녹음 속에서 진짜 휴식을 취하고 싶은 분들께 딱 맞는 공간이에요. 아침마다 공원 산책로를 따라 조깅하거나, 호수 옆 벤치에서 커피 한 잔을 즐겨 보세요.\n\n스칸디나비안 스타일의 깔끔한 인테리어에 주방 용품도 모두 완비되어 있어 간단한 요리도 가능해요. 2개의 독립된 침실이 있어 부부 두 쌍이나 부모님 동반 여행에도 완벽합니다.\n\n호스트 최지은 씨는 후쿠오카 거주 7년차로 공원 인근 숨은 맛집과 피크닉 스팟 정보를 공유해 드립니다. 비대면 체크인으로 늦은 밤 도착도 걱정 없어요.",
    locationDesc: "오호리 공원역 도보 5분 / 후쿠오카 성터 도보 7분 / 텐진 지하철 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=bright%20modern%20living%20room%20large%20window%20park%20view%20green%20trees%20minimalist%20Scandinavian%20furniture%20white%20walls%20morning%20light&width=800&height=550&seq=401&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Ohori%20park%20Fukuoka%20lake%20morning%20peaceful%20walking%20path%20green%20trees%20reflection&width=800&height=550&seq=402&orientation=landscape",
      "https://readdy.ai/api/search-image?query=modern%20Japanese%20bedroom%20clean%20minimal%20white%20linen%20natural%20light%20wooden%20floor&width=800&height=550&seq=403&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Ohori%20park%20sunset%20picnic%20bench%20scenic%20view%20lush%20greenery%20pond&width=800&height=550&seq=404&orientation=landscape",
    ],
  },
  {
    id: 5,
    name: "모모치 해변 서퍼 플랫",
    area: "모모치",
    tag: "해변 근처",
    hashtags: ["#해변근처", "#야외테라스", "#가성비"],
    rating: 4.93,
    reviewCount: 113,
    price: "₩118,000",
    maxGuests: 3,
    beds: 2,
    features: ["해변 도보 2분", "서퍼 보드 보관", "야외 테라스"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=bright%20beach%20apartment%20interior%20white%20walls%20natural%20wood%20furniture%20ocean%20breeze%20feeling%20Japanese%20coastal%20living%20space%20terrace%20view&width=600&height=400&seq=5&orientation=landscape",
    hostName: "정현우 호스트",
    needsRealPhoto: true,
    description: "모모치 해변까지 걸어서 단 2분! 바다 냄새를 맡으며 잠들고 파도 소리에 깨어나는 경험을 할 수 있는 서퍼 감성 플랫입니다. 야외 테라스에서 바라보는 하카타만의 낙조는 이 숙소의 가장 큰 자랑이에요.\n\n서퍼보드 및 스노클링 장비 보관 공간이 있어 액티비티를 즐기시는 분들께 인기예요. 자전거 대여도 가능해 해변을 따라 라이딩하기에도 좋습니다. 호스트 정현우 씨는 서핑 강습도 소개해 드릴 수 있어요.\n\n후쿠오카 타워, 시사이드 모모치 해변, 야후 오쿠돔 구장이 모두 도보 거리 내에 있어 관광과 휴양 두 마리 토끼를 다 잡을 수 있습니다.",
    locationDesc: "모모치 해변 도보 2분 / 후쿠오카 타워 도보 10분 / 야후 오쿠돔 도보 20분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=beach%20apartment%20terrace%20overlooking%20sea%20morning%20light%20wooden%20deck%20chairs%20relaxing%20coastal%20Japan&width=800&height=550&seq=501&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Momochi%20beach%20Fukuoka%20sunset%20golden%20hour%20beautiful%20sea%20skyline%20Fukuoka%20tower&width=800&height=550&seq=502&orientation=landscape",
      "https://readdy.ai/api/search-image?query=light%20bright%20beach%20house%20interior%20white%20wood%20natural%20linen%20tropical%20Japanese%20minimal&width=800&height=550&seq=503&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20tower%20Momochi%20seaside%20park%20sunny%20day%20palm%20trees%20blue%20sky%20iconic&width=800&height=550&seq=504&orientation=landscape",
    ],
  },
  {
    id: 6,
    name: "야쿠인 카페 거리 빈티지 룸",
    area: "야쿠인",
    tag: "힙한 동네",
    hashtags: ["#야쿠인", "#감성카페근처", "#가성비"],
    rating: 4.97,
    reviewCount: 178,
    price: "₩88,000",
    maxGuests: 2,
    beds: 1,
    features: ["카페 거리 중심", "빈티지 인테리어", "자전거 무료 대여"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=vintage%20bohemian%20Japanese%20studio%20room%20warm%20tones%20exposed%20brick%20wall%20retro%20furniture%20books%20plants%20cozy%20atmosphere&width=600&height=400&seq=6&orientation=landscape",
    hostName: "한소희 호스트",
    needsRealPhoto: true,
    description: "후쿠오카에서 가장 힙하고 감성 넘치는 동네, 야쿠인 카페 거리 한복판에 위치한 빈티지 룸입니다. 주변 한 블록 반경 안에 도쿄에서도 줄 서는 커피 전문점 '퍼그'와 샌드위치 맛집, 빈티지 소품샵이 밀집해 있어요.\n\n숙소 자체도 마치 세련된 편집숍처럼 꾸며져 있어요. 주인장이 직접 모은 LP 레코드와 빈티지 카메라, 식물로 채워진 공간이 매우 감성적이랍니다. 제공되는 자전거로 야쿠인부터 텐진까지 15분 만에 이동 가능해요.\n\n한소희 호스트는 야쿠인 동네 숨은 맛집 지도를 직접 제작해서 체크인 시 드리고 있어요. 카카오톡 문의 시 24시간 이내 응답 보장합니다.",
    locationDesc: "야쿠인 오도리역 도보 4분 / 텐진 지하철 5분 / 오호리 공원 자전거 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=vintage%20bohemian%20studio%20apartment%20wooden%20shelves%20vinyl%20records%20books%20plants%20retro%20lamp%20warm%20amber%20light%20cozy&width=800&height=550&seq=601&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Yakuin%20Fukuoka%20trendy%20cafe%20street%20indie%20coffee%20shop%20retro%20storefront%20daytime&width=800&height=550&seq=602&orientation=landscape",
      "https://readdy.ai/api/search-image?query=vintage%20style%20apartment%20small%20kitchen%20old%20tiles%20retro%20appliances%20charming%20nostalgic%20Japanese&width=800&height=550&seq=603&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20cycling%20street%20vintage%20bicycle%20parked%20cafe%20quiet%20alley%20Japan&width=800&height=550&seq=604&orientation=landscape",
    ],
  },
  {
    id: 7,
    name: "텐진 남 쇼핑 프리미엄 스위트",
    area: "텐진",
    tag: "쇼핑 최적",
    hashtags: ["#텐진쇼핑구역", "#쇼핑천국", "#가족여행적합"],
    rating: 4.94,
    reviewCount: 95,
    price: "₩175,000",
    maxGuests: 4,
    beds: 2,
    features: ["텐진 지하상가 연결", "대형 드레스룸", "KF94 마스크 제공"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=luxury%20modern%20Japanese%20apartment%20suite%20bedroom%20with%20elegant%20interior%20design%20premium%20bedding%20clean%20minimalist%20aesthetic%20Fukuoka%20city%20center&width=600&height=400&seq=7&orientation=landscape",
    hostName: "오민준 호스트",
    needsRealPhoto: true,
    description: "쇼핑을 사랑하는 여행자를 위한 최적의 베이스캠프! 텐진 지하상가 출구와 직접 연결되어 어떤 날씨에도 편하게 쇼핑을 즐길 수 있어요. 미츠코시, 이와타야, 파르코, 솔라리아 플라자까지 모두 5분 이내 접근 가능합니다.\n\n쇼핑 후 짐을 가득 들고 와도 걱정 없어요. 대형 드레스룸이 있어 쇼핑백 정리에 딱이고, 여행용 캐리어도 여러 개 보관 가능합니다. KF94 마스크와 위생 키트를 체크인 시 제공해드려요.\n\n호스트 오민준 씨는 드럭스토어·면세점 쇼핑 꿀팁과 택스 리펀드 절차를 한국어로 상세하게 안내해드릴 수 있어요. 쇼핑 리스트를 미리 공유해 주시면 맞춤 쇼핑 루트도 추천드립니다.",
    locationDesc: "텐진 지하상가 직결 / 이와타야 백화점 도보 2분 / 솔라리아 플라자 도보 3분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=premium%20hotel%20suite%20bedroom%20luxury%20interior%20elegant%20bed%20large%20closet%20modern%20Japanese%20design&width=800&height=550&seq=701&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Tenjin%20Fukuoka%20underground%20shopping%20arcade%20crowded%20bright%20stores%20walkway&width=800&height=550&seq=702&orientation=landscape",
      "https://readdy.ai/api/search-image?query=modern%20living%20room%20two%20bedroom%20apartment%20premium%20sofa%20marble%20accent%20contemporary%20design&width=800&height=550&seq=703&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Tenjin%20department%20store%20shopping%20fashion%20street%20daytime%20busy&width=800&height=550&seq=704&orientation=landscape",
    ],
  },
  {
    id: 8,
    name: "하카타 전통 마치야 게스트하우스",
    area: "하카타",
    tag: "일본 전통",
    hashtags: ["#하카타역근처", "#일본전통체험", "#감성숙소"],
    rating: 4.92,
    reviewCount: 156,
    price: "₩105,000",
    maxGuests: 3,
    beds: 2,
    features: ["100년 전통 마치야", "다다미 체험", "유카타 제공"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=traditional%20Japanese%20machiya%20townhouse%20interior%20tatami%20room%20wooden%20beams%20shoji%20screens%20warm%20natural%20light%20authentic%20heritage%20atmosphere&width=600&height=400&seq=8&orientation=landscape",
    hostName: "신아름 호스트",
    needsRealPhoto: true,
    description: "100년 넘은 전통 마치야(町家)를 한국인 호스트가 정성스럽게 리노베이션한 게스트하우스입니다. 현대적인 편의시설을 갖추면서도 일본 전통의 멋을 그대로 살린 공간으로, 국내외 여행 매거진에도 소개된 바 있어요.\n\n다다미 방에서 자는 경험, 유카타를 입고 하카타 거리를 걷는 것, 아침에 일본 전통 차를 즐기는 것 모두 여기서 가능합니다. 체크인 시 유카타 2벌이 기본 제공돼요.\n\n호스트 신아름 씨는 마치야의 역사와 하카타 전통 축제 이야기를 한국어로 재미있게 들려드립니다. 근처 하카타 기온 야마카사 축제 루트와 스미요시 신사도 꼭 방문해 보세요.",
    locationDesc: "하카타역 도보 8분 / 스미요시 신사 도보 5분 / 기온 거리 도보 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=traditional%20Japanese%20machiya%20interior%20tatami%20floor%20shoji%20screens%20wooden%20pillars%20authentic%20warm%20natural%20light&width=800&height=550&seq=801&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20yukata%20traditional%20garden%20stone%20path%20zen%20garden%20wooden%20architecture&width=800&height=550&seq=802&orientation=landscape",
      "https://readdy.ai/api/search-image?query=traditional%20Japanese%20tea%20ceremony%20matcha%20tea%20room%20wooden%20table%20tatami%20minimalist&width=800&height=550&seq=803&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Hakata%20Gion%20Yamakasa%20festival%20traditional%20Japan%20street%20decorations&width=800&height=550&seq=804&orientation=landscape",
    ],
  },
  {
    id: 9,
    name: "후쿠오카 타워 뷰 하이라이즈",
    area: "시사이드모모치",
    tag: "시티뷰 최고",
    hashtags: ["#시티뷰", "#후쿠오카타워", "#커플추천"],
    rating: 4.98,
    reviewCount: 44,
    price: "₩195,000",
    maxGuests: 2,
    beds: 1,
    features: ["후쿠오카 타워 뷰", "고층 전망", "넓은 발코니"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=high%20rise%20apartment%20with%20stunning%20Fukuoka%20tower%20city%20skyline%20view%20at%20night%20modern%20interior%20floor%20to%20ceiling%20windows%20panoramic%20view&width=600&height=400&seq=9&orientation=landscape",
    hostName: "강태양 호스트",
    needsRealPhoto: true,
    description: "후쿠오카의 상징 후쿠오카 타워를 눈앞에서 바라볼 수 있는 고층 하이라이즈 아파트입니다. 플로어투씰링 창문으로 펼쳐지는 하카타만과 후쿠오카 타워의 야경은 한국에서도 인스타그램으로 많이 알려진 뷰예요.\n\n넓은 발코니에서 여유롭게 커피 한 잔 하며 바라보는 저녁 노을은 평생 기억에 남을 경험이에요. 인테리어는 모노톤의 모던 스타일로, 커플 여행자들에게 특히 인기가 높습니다.\n\n강태양 호스트는 후쿠오카 일몰 명소와 야경 포토스팟 정보를 상세히 공유해드립니다. 체크인 시 환영 샴페인과 과일 바구니도 준비되어 있어요.",
    locationDesc: "후쿠오카 타워 도보 5분 / 모모치 해변 도보 10분 / 마리나타운 차량 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=high%20rise%20apartment%20floor%20to%20ceiling%20window%20night%20city%20view%20Fukuoka%20tower%20glowing%20modern%20dark%20interior%20romantic&width=800&height=550&seq=901&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20tower%20night%20illuminated%20landmark%20reflection%20sea%20dark%20sky%20beautiful&width=800&height=550&seq=902&orientation=landscape",
      "https://readdy.ai/api/search-image?query=luxury%20apartment%20wide%20balcony%20city%20panoramic%20view%20dusk%20modern%20outdoor%20furniture&width=800&height=550&seq=903&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Momochi%20beach%20sunset%20panorama%20cityscape%20bay%20glowing%20sky&width=800&height=550&seq=904&orientation=landscape",
    ],
  },
  {
    id: 10,
    name: "니시진 로컬 패밀리 홈",
    area: "니시진",
    tag: "로컬 분위기",
    hashtags: ["#로컬동네", "#가족여행적합", "#아침식사제공"],
    rating: 4.91,
    reviewCount: 83,
    price: "₩135,000",
    maxGuests: 5,
    beds: 3,
    features: ["현지인 동네", "텃밭 체험", "아침 식사 제공"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=cozy%20Japanese%20family%20home%20interior%20local%20neighborhood%20warm%20homey%20atmosphere%20kitchen%20living%20room%20wooden%20furniture%20welcoming&width=600&height=400&seq=10&orientation=landscape",
    hostName: "윤미래 호스트",
    needsRealPhoto: true,
    description: "관광객이 거의 없는 진짜 후쿠오카 로컬 동네, 니시진에 위치한 아늑한 패밀리 홈입니다. 호스트 윤미래 씨는 후쿠오카에 15년째 살고 있는 베테랑 한국인으로, 완전한 현지인의 삶을 체험할 수 있도록 도와드려요.\n\n아침에는 호스트가 직접 준비한 조식을 드실 수 있어요. 주먹밥, 미소 된장국, 신선한 채소 등 건강한 일식 아침 식사가 매일 제공됩니다. 작은 텃밭에서 직접 채소를 수확해 먹는 경험도 할 수 있어요.\n\n관광 명소보다 진짜 일본인의 일상을 경험하고 싶은 분들께 강력 추천드립니다. 근처 재래시장과 동네 목욕탕(센토) 방문 안내도 해드려요.",
    locationDesc: "니시진역 도보 6분 / 오호리 공원 자전거 15분 / 후쿠오카 시청 지하철 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=cozy%20warm%20Japanese%20family%20home%20living%20room%20dining%20area%20wooden%20table%20breakfast%20morning%20light%20homey&width=800&height=550&seq=1001&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Japanese%20home%20garden%20small%20vegetable%20garden%20herbs%20morning%20light%20wooden%20house&width=800&height=550&seq=1002&orientation=landscape",
      "https://readdy.ai/api/search-image?query=traditional%20Japanese%20breakfast%20rice%20miso%20soup%20pickles%20fish%20bowl%20wooden%20table&width=800&height=550&seq=1003&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20local%20neighborhood%20quiet%20residential%20street%20Japan%20morning%20bicycle&width=800&height=550&seq=1004&orientation=landscape",
    ],
  },
  {
    id: 11,
    name: "기온 야마치 예술가의 집",
    area: "기온",
    tag: "아트 감성",
    hashtags: ["#기온", "#아트감성", "#조용한숙소"],
    rating: 4.96,
    reviewCount: 61,
    price: "₩145,000",
    maxGuests: 3,
    beds: 2,
    features: ["갤러리 인근", "아트 소품 가득", "낮은 층 조용함"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=artistic%20Japanese%20apartment%20interior%20with%20art%20pieces%20on%20walls%20creative%20gallery%20style%20decor%20neutral%20tones%20unique%20design%20elements%20curated%20aesthetic&width=600&height=400&seq=11&orientation=landscape",
    hostName: "임도윤 호스트",
    needsRealPhoto: true,
    description: "화가 출신 호스트 임도윤 씨가 직접 큐레이션한 아트 감성 공간입니다. 벽면을 채운 로컬 아티스트들의 작품과 세심하게 배치된 조각품들이 숙소 자체를 하나의 작은 갤러리로 만들고 있어요.\n\n기온 갤러리 거리 바로 옆에 위치해 있어, 커피 한 잔 들고 인근 갤러리들을 산책하는 여유로운 오전을 즐길 수 있습니다. 조용하고 아늑한 분위기라 책 읽기나 혼자 여행에도 딱이에요.\n\n임도윤 호스트는 후쿠오카 현지 아트 이벤트와 전시 정보를 공유해드리며, 숙소에 걸린 작품들의 구매 연결도 도와드릴 수 있습니다. 예술과 여행을 동시에 즐기고 싶은 분들께 추천해요.",
    locationDesc: "기온역 도보 5분 / 하카타역 도보 12분 / 캐널시티 도보 15분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=art%20gallery%20home%20interior%20Japanese%20paintings%20on%20white%20walls%20minimalist%20furniture%20curated%20aesthetic%20creative%20loft&width=800&height=550&seq=1101&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Gion%20art%20gallery%20street%20small%20independent%20exhibition%20Japan&width=800&height=550&seq=1102&orientation=landscape",
      "https://readdy.ai/api/search-image?query=artist%20home%20studio%20workspace%20desk%20painting%20tools%20plants%20natural%20light%20creative&width=800&height=550&seq=1103&orientation=landscape",
      "https://readdy.ai/api/search-image?query=minimalist%20bedroom%20art%20pieces%20wall%20Japanese%20design%20neutral%20tones%20calm%20peaceful&width=800&height=550&seq=1104&orientation=landscape",
    ],
  },
  {
    id: 12,
    name: "캐널시티 어번 스튜디오",
    area: "캐널시티",
    tag: "쇼핑몰 바로 옆",
    hashtags: ["#캐널시티", "#쇼핑천국", "#관광최적"],
    rating: 4.90,
    reviewCount: 127,
    price: "₩98,000",
    maxGuests: 2,
    beds: 1,
    features: ["캐널시티 도보 1분", "라멘 스타디움 근처", "관광 최적"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=compact%20modern%20Japanese%20studio%20apartment%20urban%20city%20interior%20clean%20lines%20contemporary%20design%20city%20location%20compact%20space%20well%20organized&width=600&height=400&seq=12&orientation=landscape",
    hostName: "류성민 호스트",
    needsRealPhoto: true,
    description: "후쿠오카 최대 복합 쇼핑몰 캐널시티 하카타 바로 옆, 도보 1분 거리에 있는 깔끔한 어번 스튜디오입니다. 라멘 스타디움, 영화관, 쇼핑, 레스토랑까지 모두 한 곳에서 해결할 수 있어 이동 최소화를 원하는 여행자들에게 인기 만점이에요.\n\n실용적이고 깔끔하게 설계된 내부는 장기 여행자에게도 편안합니다. 고속 와이파이와 넷플릭스 제공으로 비 오는 날 홈캉스도 완벽해요.\n\n호스트 류성민 씨는 후쿠오카 라멘 투어(나가하마, 하카타, 이마이즈미 3대 거리 라멘) 루트를 상세히 안내해드립니다. 후쿠오카 입문 여행자들에게 강력 추천드리는 위치예요.",
    locationDesc: "캐널시티 하카타 도보 1분 / 나카스 도보 5분 / 하카타역 도보 12분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=Canal%20City%20Hakata%20Fukuoka%20shopping%20complex%20canal%20interior%20fountain%20waterway%20neon%20lights&width=800&height=550&seq=1201&orientation=landscape",
      "https://readdy.ai/api/search-image?query=compact%20modern%20studio%20apartment%20clean%20minimal%20Japanese%20urban%20interior%20organized%20efficient%20space&width=800&height=550&seq=1202&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20ramen%20stadium%20hakata%20ramen%20bowl%20rich%20broth%20noodles%20toppings%20Japanese%20food&width=800&height=550&seq=1203&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20Canal%20City%20exterior%20evening%20lights%20fountain%20reflection%20shopping&width=800&height=550&seq=1204&orientation=landscape",
    ],
  },
  {
    id: 13,
    name: "스미요시 조용한 정원 하우스",
    area: "스미요시",
    tag: "정원 있는 집",
    hashtags: ["#독채", "#정원있는집", "#온수욕조"],
    rating: 4.97,
    reviewCount: 38,
    price: "₩168,000",
    maxGuests: 4,
    beds: 2,
    features: ["일본식 정원", "온수 욕조", "완전 독채"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=Japanese%20house%20with%20traditional%20garden%20zen%20garden%20stone%20path%20moss%20garden%20interior%20peaceful%20private%20relaxing%20atmosphere%20natural%20wooden%20architecture&width=600&height=400&seq=13&orientation=landscape",
    hostName: "천예린 호스트",
    needsRealPhoto: true,
    description: "완전 독채 사용이 가능한 일본식 정원 하우스입니다. 이끼와 돌로 가꾼 작은 정원, 대나무 울타리, 그리고 노천 온수 욕조(오픈에어 바스)가 있어 마치 료칸에 온 것 같은 프리미엄 경험을 합리적인 가격에 즐길 수 있어요.\n\n아무도 방해하지 않는 완전한 독채라 가족이나 소그룹 여행에 딱 맞습니다. 밤에 정원 조명을 켜고 온수 욕조에 몸을 담그는 경험은 정말 특별해요. 근처 편의점과 슈퍼마켓도 가까워 생활 편의도 갖춰져 있어요.\n\n호스트 천예린 씨는 일본 목욕 문화 에티켓부터 후쿠오카 현지인만 아는 료칸 맛집 정보까지 한국어로 친절하게 안내해드립니다.",
    locationDesc: "스미요시역 도보 7분 / 하카타역 버스 10분 / 캐널시티 버스 12분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=traditional%20Japanese%20garden%20house%20zen%20stone%20garden%20bamboo%20fence%20moss%20private%20peaceful%20twilight&width=800&height=550&seq=1301&orientation=landscape",
      "https://readdy.ai/api/search-image?query=outdoor%20Japanese%20hot%20tub%20garden%20soaking%20tub%20night%20stone%20lantern%20bamboo%20wooden%20deck&width=800&height=550&seq=1302&orientation=landscape",
      "https://readdy.ai/api/search-image?query=traditional%20Japanese%20tatami%20room%20interior%20shoji%20screens%20paper%20wall%20sliding%20door%20wooden%20floor&width=800&height=550&seq=1303&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Japanese%20zen%20garden%20raked%20gravel%20rocks%20moss%20stepping%20stones%20tranquil%20peaceful&width=800&height=550&seq=1304&orientation=landscape",
    ],
  },
  {
    id: 14,
    name: "하카타 비즈니스 클린 원룸",
    area: "하카타",
    tag: "비즈니스 여행",
    hashtags: ["#하카타역근처", "#가성비", "#비즈니스여행"],
    rating: 4.89,
    reviewCount: 215,
    price: "₩75,000",
    maxGuests: 1,
    beds: 1,
    features: ["고속 와이파이", "책상 완비", "세탁 서비스"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=clean%20minimal%20Japanese%20business%20apartment%20single%20room%20white%20walls%20desk%20workspace%20high%20speed%20wifi%20professional%20tidy%20organized&width=600&height=400&seq=14&orientation=landscape",
    hostName: "배지훈 호스트",
    needsRealPhoto: true,
    description: "출장, 장기 체류, 혼자 여행 모두에 최적화된 가성비 비즈니스 원룸입니다. 군더더기 없이 깔끔하게 정돈된 공간에 고속 와이파이(1Gbps), 55인치 모니터 겸용 TV, 인체공학적 책상과 의자가 완비돼 있어요.\n\n세탁 서비스(유료)도 가능하고, 코인 세탁기 사용 안내도 해드립니다. 24시간 무인 체크인이 가능해 야간 도착도 걱정 없어요. 냉장고와 전자레인지, 간단한 조리도 가능한 IH 인덕션이 있어요.\n\n후쿠오카에서 가장 많은 후기 수를 자랑하는 숙소 중 하나로, 재방문율 60%를 자랑합니다. 배지훈 호스트는 출장자를 위한 회의 장소 추천과 비즈니스 지원도 제공합니다.",
    locationDesc: "하카타역 도보 6분 / 후쿠오카 비즈니스 센터 도보 10분 / 공항 지하철 5분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=clean%20minimal%20business%20apartment%20workspace%20desk%20monitor%20ergonomic%20chair%20white%20walls%20professional%20organized&width=800&height=550&seq=1401&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Hakata%20station%20Fukuoka%20interior%20commuters%20modern%20Japan%20transportation%20hub&width=800&height=550&seq=1402&orientation=landscape",
      "https://readdy.ai/api/search-image?query=single%20room%20Japanese%20apartment%20neat%20bed%20white%20linen%20minimal%20simple%20clean&width=800&height=550&seq=1403&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fukuoka%20business%20district%20office%20buildings%20modern%20skyline%20daytime%20professional&width=800&height=550&seq=1404&orientation=landscape",
    ],
  },
  {
    id: 15,
    name: "마이즈루 파크 옆 신혼 아파트",
    area: "마이즈루",
    tag: "신혼여행 특화",
    hashtags: ["#신혼여행", "#커플추천", "#스파욕조"],
    rating: 4.99,
    reviewCount: 72,
    price: "₩185,000",
    maxGuests: 2,
    beds: 1,
    features: ["마이즈루 공원 인근", "꽃 장식 서비스", "스파 욕조"],
    airbnbUrl: "https://www.airbnb.co.kr/s/Fukuoka--Japan/homes",
    image: "https://readdy.ai/api/search-image?query=romantic%20luxury%20Japanese%20apartment%20honeymoon%20suite%20elegant%20decor%20flowers%20soft%20lighting%20premium%20bedding%20intimate%20cozy%20atmosphere&width=600&height=400&seq=15&orientation=landscape",
    hostName: "송하은 호스트",
    needsRealPhoto: true,
    description: "신혼여행과 기념일 여행을 위해 특별히 기획된 로맨틱 아파트입니다. 체크인 전 호스트에게 요청하면 꽃 장식, 와인, 케이크 등 서프라이즈 세팅을 준비해드려요. 이 서비스만으로도 SNS에서 엄청난 화제가 된 숙소예요.\n\n스파 욕조가 있는 욕실에서 보글보글 버블 바스를 즐길 수 있고, 창밖으로는 벚꽃 명소로 유명한 마이즈루 공원이 내려다보입니다. 봄 시즌에는 벚꽃 뷰가 정말 압권이에요.\n\n호스트 송하은 씨는 후쿠오카에서 결혼한 한국인으로, 커플 여행의 모든 것을 전문적으로 서포트해드립니다. 프로포즈 장소 추천, 레스토랑 예약 대행, 기념사진 스팟 안내까지 모두 가능해요.",
    locationDesc: "마이즈루 공원 도보 3분 / 텐진역 도보 7분 / 후쿠오카 성터 도보 10분",
    detailImages: [
      "https://readdy.ai/api/search-image?query=romantic%20luxury%20apartment%20bedroom%20flower%20decoration%20rose%20petals%20candles%20champagne%20honeymoon%20setup%20warm%20light%20intimate&width=800&height=550&seq=1501&orientation=landscape",
      "https://readdy.ai/api/search-image?query=luxury%20spa%20bathroom%20bubble%20bath%20tub%20candles%20romantic%20flowers%20petals%20premium&width=800&height=550&seq=1502&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Maizuru%20Park%20Fukuoka%20cherry%20blossom%20sakura%20pink%20trees%20spring%20beautiful%20Japan&width=800&height=550&seq=1503&orientation=landscape",
      "https://readdy.ai/api/search-image?query=romantic%20dinner%20table%20for%20two%20candles%20wine%20flowers%20restaurant%20Japan%20evening&width=800&height=550&seq=1504&orientation=landscape",
    ],
  },
];

export const areas = ["전체", "텐진", "하카타", "나카스", "오호리", "모모치", "야쿠인", "기온", "캐널시티"];
